import { IconSizes, CheckCircleIcon, CubeIcon } from '@newcore/icons';
import { FontWeights } from '@newcore/ui/enums/font-weights';
import { TextSizes } from '@newcore/ui/enums/typography-text-sizes';
import { Text } from '@newcore/ui/typography';
import newcoreIcon from '@/assets/newcore-app-icon.svg';

interface ConsentAppHeaderProps {
  appName: string;
  tenantName: string;
  logoUri?: string | null;
  logoFailed: boolean;
  onLogoError: () => void;
}

export function ConsentAppHeader({
  appName,
  tenantName,
  logoUri,
  logoFailed,
  onLogoError,
}: ConsentAppHeaderProps) {
  return (
    <>
      <div className='flex items-center gap-1'>
        {logoUri && !logoFailed ? (
          <img
            className='w-12 h-12 rounded-[10px] border border-secondary object-contain p-1.5'
            src={logoUri}
            alt={`${appName} logo`}
            referrerPolicy='no-referrer'
            onError={onLogoError}
          />
        ) : (
          <div
            className='w-12 h-12 flex items-center justify-center rounded-[10px] border border-secondary bg-secondary'
            data-testid='consent-logo-fallback'
          >
            <CubeIcon className='text-fg-quaternary' size={IconSizes.LG} />
          </div>
        )}
        <div className='flex items-center gap-1 px-1'>
          <span className='w-[3px] h-[3px] rounded-full bg-secondary' />
          <span className='w-[3px] h-[3px] rounded-full bg-secondary' />
          <CheckCircleIcon
            className='text-fg-success-primary'
            size={IconSizes.SM}
            strokeWidth={2.5}
          />
          <span className='w-[3px] h-[3px] rounded-full bg-secondary' />
          <span className='w-[3px] h-[3px] rounded-full bg-secondary' />
        </div>
        <div className='w-12 h-12 flex items-center justify-center rounded-[10px] border border-secondary'>
          <img
            className='w-full h-full rounded-[10px] object-contain'
            src={newcoreIcon}
            alt='NewCore'
          />
        </div>
      </div>

      <div className='flex flex-col items-center gap-1 w-[352px] max-w-full text-center'>
        <Text
          size={TextSizes.MD}
          weight={FontWeights.SEMIBOLD}
          className='leading-6 text-primary'
          data-testid='consent-title'
        >
          {appName} wants access to {tenantName}
        </Text>
        <Text
          size={TextSizes.SM}
          weight={FontWeights.REGULAR}
          className='leading-5 text-secondary'
        >
          Review what this client will be able to do before allowing access
        </Text>
      </div>
    </>
  );
}
